<template>
  <v-container fluid>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            Experiment Logs
            <v-spacer></v-spacer>
            <v-btn medium depressed flat icon color="white" 
              @click="fetchLogs()">
              <v-icon medium>cached</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="headers"
            :items="items"
            :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
            :loading="logListLoading">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.createdDate | formatDate }}</td>
                <td>{{ props.item.time }}</td>
                <td>{{ props.item.instances }}</td>
                <td v-for="key of jobLog.labels">
                  {{ props.item.labelCounts[key] }}
                </td>
              </template>
              <template v-slot:body.append>
                <tr>
                  <td></td>
                  <td>
                    <v-select v-model="level" type="select" label="Level Filter"></v-select>
                  </td>
                  <td colspan="4"></td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
      default: ''
    },
    logId: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      headers: [
      ],
      items: [],
      logListLoading: false,
      pagination: {
        sortBy: 'time'
      },
      jobLog: {}
    }
  },
  created () {
    this.logListLoading = true
    this.fetchJobLog()
    this.fetchLogs()
  },
  methods: {
    fetchJobLog() {
      this.axios.get(`/jobs/${this.id}/logs/${this.logId}/scoring-job-log/`)
        .then(response => {
          var item = response.data
          this.jobLog = {
            id: item.id,
            labels: item.labels
          }
          // update headers
          this.headers = [
              {text: 'Created Date', sortable: true, value: 'createdDate'},
              {text: 'Time (s)', sortable: true, value: 'time'},
              {text: 'Instances', sortable: true, value: 'instances'},
          ]
          for (var key of this.jobLog.labels) {
            this.headers.push({
              text: key,
              sortable: false,
              value: key
            })
          }
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
        })
    },
    fetchLogs () {
      this.items = []
      this.axios.get(`/jobs/${this.id}/logs/${this.logId}/`)
        .then(response => {
          response.data.forEach(log => {
            var item = {
              createdDate: log.created_date,
              time: log.time,
              instances: log.instance_count,
              labelCounts: log.label_counts
            }
            this.items.push(item)
          })
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.logListLoading = false
        })
    }
  }
}
</script>

<style>

</style>
